import { render, staticRenderFns } from "./centered-card.vue?vue&type=template&id=c54a9f44&scoped=true"
import script from "./centered-card.vue?vue&type=script&lang=js"
export * from "./centered-card.vue?vue&type=script&lang=js"
import style0 from "./centered-card.vue?vue&type=style&index=0&id=c54a9f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54a9f44",
  null
  
)

export default component.exports